import { default as React } from 'react';
import { IconButton, makeStyles, Tooltip } from '@material-ui/core';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewListIcon from '@mui/icons-material/ViewList';

export type ViewMode = 'cards' | 'table';

const useStyles = makeStyles(theme => ({
  toggleGroup: {
    display: 'inline-flex',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
  },
  toggleButton: {
    borderRadius: 0,
    padding: theme.spacing(0.75),
    '&:not(:last-child)': {
      borderRight: `1px solid ${theme.palette.divider}`,
    },
  },
  active: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

export const CatalogViewToggle = ({
  viewMode,
  onChange,
}: {
  viewMode: ViewMode;
  onChange: (mode: ViewMode) => void;
}) => {
  const classes = useStyles();

  return (
    <div className={classes.toggleGroup}>
      <Tooltip title="Card view">
        <IconButton
          size="small"
          className={`${classes.toggleButton} ${
            viewMode === 'cards' ? classes.active : ''
          }`}
          onClick={() => onChange('cards')}
        >
          <ViewModuleIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Table view">
        <IconButton
          size="small"
          className={`${classes.toggleButton} ${
            viewMode === 'table' ? classes.active : ''
          }`}
          onClick={() => onChange('table')}
        >
          <ViewListIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </div>
  );
};
